import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { UpdateType } from '@debbie/common/dist/updates';
import { selectCaseUpdates } from '@debbie/cortex/dist/case/selectors';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors';
import THEME from '../theme';
import { UserPreview } from '.';
const OppositionHistory = (props) => {
    const lang = useSelector((s) => s.lang);
    const singleCase = useSelector((s) => props.caseId ? selectCaseById(s, props.caseId) : null);
    const updates = useSelector((s) => singleCase && selectCaseUpdates(s, singleCase.caseId));
    const oppositions = updates
        ? updates.filter((update) => {
            if (update.refId === props.interaction.id) {
                if ([UpdateType.OPPOSITION, UpdateType.NOTOPPOSITION].includes(update.updateTypeId)) {
                    return true;
                }
            }
            return false;
        })
        : [];
    oppositions.sort((a, b) => {
        if (moment(a.createdAt) > moment(b.createdAt)) {
            return 1;
        }
        else if (moment(a.createdAt) < moment(b.createdAt)) {
            return -1;
        }
        return 0;
    });
    return (React.createElement(React.Fragment, null, oppositions.map((opposition) => (React.createElement(Block, { key: opposition.updateId },
        React.createElement(Inline, null,
            opposition.createdByUser && (React.createElement(UserPreview, { user: opposition.createdByUser })),
            React.createElement(Timestamp, null, moment(opposition.createdAt).format(THEME.DATE_FORMAT_LONG)),
            opposition.updateTypeId === UpdateType.OPPOSITION
                ? lang.interactions.opposition
                : lang.interactions.notOpposition),
        opposition.update && React.createElement(Note, null, opposition.update))))));
};
export default OppositionHistory;
const Timestamp = styled.div `
  color: ${THEME.DARK_COLOR_SECONDARY};
  font-size: 0.8em;
  padding-right: 5px;
`;
const Inline = styled.div `
  display: inline-flex;
  align-items: center;
  margin: 5px 0px 5px 0px;
`;
const Block = styled.div `
  display: block;
`;
const Note = styled.div `
  background-color: #e6e6e6;
  border-radius: 2px;
  padding: 10px;
  margin-left: 30px;
  width: fit-content;
`;
//# sourceMappingURL=OppositionHistory.js.map